export const potashAvgPriceMock = {
    title: "Potash avg. Price",
    type: "POTASH_AVG",
    navigation: {
        type: "GraphNavigation",
        nav: {
            qtd: [
                {
                    title: "C",
                    graph: {
                        columnType: 'KMT',
                        data: [
                            {
                                colGroupName: 2020,
                                colName: 'Q1',
                                current: {
                                    value: 990,
                                },
                                cif: 1350,
                                fob: 1100,
                            },
                            {
                                colGroupName: 2020,
                                colName: 'Q2',
                                current: {
                                    value: 800,
                                },
                                cif: 1150,
                                fob: 950,
                            },
                            {
                                colGroupName: 2020,
                                colName: 'Q3',
                                current: {
                                    value: 1050,
                                },
                                cif: 1300,
                                fob: 1200,
                            },
                            {
                                colGroupName: 2020,
                                colName: 'Q4',
                                current: {
                                    value: 700,
                                },
                                cif: 1350,
                                fob: 750,
                                isDefault: true
                            },
                            {
                                colGroupName: 2021,
                                colName: 'Q1',
                                current: {
                                    value: 1100,
                                },
                                cif: 1350,
                                fob: 1290,
                            },
                            {
                                colGroupName: 2021,
                                colName: 'Q2',
                                current: {
                                    value: 1200,
                                },
                                cif: 1400,
                                fob: 1300,
                            },
                            {
                                colGroupName: 2021,
                                colName: 'Q3',
                                current: null,
                                cif: null,
                                fob: null,
                            },
                            {
                                colGroupName: 2021,
                                colName: 'Q4',
                                current: null,
                                cif: null,
                                fob: null,
                            },
                        ]
                    }
                }
            ]
        }
    }
};
